export default __webpack_public_path__ + "static/media/fotoRostro.8fac13f0.svg";